<template>
  <Link
    :field="fields?.NavigationUrl"
    class="block group w-45 text-paragraph-color no-underline active:no-underline"
    :class="fields?.classes"
    :data-test-id="dataTestId"
  >
    <Image
      :media="fields?.Image"
      class="rounded-lg border-[1.5px] border-racq-pale-blue mb-3 w-45 h-26.25 shadow-md group-hover:shadow-1xl group-active:shadow-none"
      width="180"
      height="105"
    />
    <div class="truncate"><Text :field="fields?.Title" class="text-m-bold text-ellipsis group-active:underline" /></div>
    <div class="line-clamp-2">
      <RichText :field="fields?.Content" class="text-sm group-active:text-racq-med-grey" />
    </div>
  </Link>
</template>

<script setup lang="ts">
import { usePageStore } from '@/store';
import { Link, Image, RichText, Text } from '@sitecore-jss/sitecore-jss-vue';
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------
const props = defineProps<{
  fields?: ComponentFields;
  rendering?: ComponentRendering;
}>();

const dataTestId = usePageStore().dataTestId(props.rendering);
</script>
